import { COMMON_CHUNK_NAME } from "../../../../../const/generator";
import {
  BuilderComponentPlugin,
  BuilderComponentPluginFactory,
  ChunkType,
  FileType,
  ICodeStruct,
  IParseResult,
} from "../../../../../types";
import { buildDataSourceDependencies } from "../../../../../utils/dataSource";
import { getSlotRelativePath } from "../../../../../utils/pathHelper";

export type GantRouteJsonPluginConfig = {
  route: any[];
  /**
   * 数据源配置
   */
  datasourceConfig?: {
    /** 数据源引擎的版本 */
    engineVersion?: string;
    /** 数据源引擎的包名 */
    enginePackage?: string;
    /** 数据源 handlers 的版本 */
    handlersVersion?: {
      [key: string]: string;
    };
    /** 数据源 handlers 的包名 */
    handlersPackages?: {
      [key: string]: string;
    };
  };
  /** 包名 */
  packageName?: string;
  /** 版本 */
  packageVersion?: string;
};

const pluginFactory: BuilderComponentPluginFactory<
  GantRouteJsonPluginConfig
> = (cfg) => {
  const plugin: BuilderComponentPlugin = async (pre: ICodeStruct) => {
    const next: ICodeStruct = {
      ...pre,
    };

    const ir = next.ir as IParseResult;

    const rootPath = getSlotRelativePath({
      contextData: next.contextData,
      from: 'root',
      to: "pages",
    });
    const lowcodeConfigJSON = {
      name: cfg?.packageName || "gant-lowcode-app",
      version: cfg?.packageVersion || "0.0.0",
      routes: ir.globalRouter?.routes.map((route) => ({
        path: `/**/${route.path}`,
        name: route.fileName,
        component: `${rootPath}${route.componentName}`,
      })),
      dependencies: {
        // 数据源相关的依赖:
        ...buildDataSourceDependencies(ir.project!, cfg?.datasourceConfig),
      },
      ...(ir.project?.config || {}),
    };

    ir.project!.packages.forEach((packageInfo) => {
      lowcodeConfigJSON.dependencies[packageInfo.package] = packageInfo.version;
    });

    next.chunks.push({
      type: ChunkType.JSON,
      fileType: FileType.JSON,
      name: COMMON_CHUNK_NAME.FileMainContent,
      content: lowcodeConfigJSON,
      linkAfter: [],
    });

    return next;
  };
  return plugin;
};

export default pluginFactory;
